import _find from "lodash/find";
export var UNKNOWN_POINTER = 'unknown';
export var NO_POINTER = 'none';
export var COARSE_POINTER = 'coarse';
export var FINE_POINTER = 'fine'; // determines if the browser's primary pointer is
// coarse (e.g. touch, assistive) or fine (e.g. mouse)

export var getPointerType = function getPointerType() {
  // can we even determine media?
  var _ref = typeof window === 'undefined' ? {} : window,
      matchMedia = _ref.matchMedia;

  if (!matchMedia) {
    return UNKNOWN_POINTER;
  }

  var pointers = [COARSE_POINTER, FINE_POINTER, NO_POINTER]; // see if the browser knows what pointer.

  return _find(pointers, function (p) {
    return window.matchMedia("(pointer: ".concat(p, ")")).matches && p;
  }) || UNKNOWN_POINTER;
};